import React from 'react';
import { FormattedMessage } from 'react-intl';
import UserPlusIcon from '../../../../icons/UserPlus';
import { IconWrapper, ClickableMenuItem, MemberItemInfo } from './styles';
const AddNewMember = ({ onClick }) => {
    return (React.createElement(ClickableMenuItem, { onClick: onClick },
        React.createElement(IconWrapper, null,
            React.createElement(UserPlusIcon, null)),
        React.createElement(MemberItemInfo, null,
            React.createElement(FormattedMessage, { id: "chat.member.addMore" }))));
};
export default AddNewMember;
//# sourceMappingURL=AddNewMember.js.map